<template>
    <loading :loading="isLoading">
        <div class='hotel-scenic-new-detail'>
            <img class="toBackImg" @click="goBack" src="https://cdn.133.cn/ticket/images/hangban/vue/hltrip/icon/home-back@2x.png" />

            <div class="advertisement">
                <div class="slider">
                    <template v-if="productDetail.images && productDetail.images.length">
                        <swipe-comp :ads="productDetail.images" :show="swipeShow" :axiosObj='axiosObj' :showPhotoList='true' :typeOfBusiness='1' />
                        <!-- 返回按钮 -->
                    </template>
                </div>
            </div>
            <div class="mainTitleWrap"></div>
            <div class="main-title">
                <div class="price">
                    <span class="price-unit">¥</span><span class="price-txt">{{ productDetail.productPrice }}</span><del class="price-del">¥{{ productDetail.productOriginalPrice }}</del>
                    <span class="price-tip">订酒店赠门票</span>
                </div>
                <div class="title">{{ productDetail.scenicSpotName }}</div>
                <div class="time">
                    <div class="time-left">
                        <template v-if="productDetail.operatingStatus">
                            <span :style="{ fontWeight: 550, marginRight: '4px', color: operatingStatusObj[productDetail.operatingStatus].color }">{{ operatingStatusObj[productDetail.operatingStatus].label }}</span><span>{{ productDetail.scenicSpotOpenTimes[0].timeDesc }}</span>
                        </template>
                        <span v-else style="color: #B7B7B7;">暂无营业信息</span>
                    </div>
                    <div class="time-right">
                        <span class="time-right-txt" @click='openIntroduction'>简介/攻略</span>
                        <img class="time-right-icon" src="@/assets/list/arrow-right.png" alt="" />
                    </div>
                </div>
                <div class="line" v-if="productDetail.address"></div>
                <div class="address" v-if="productDetail.address">
                    <div class="address-left">{{ productDetail.address }}</div>
                    <div class="address-right">
                        <div class="address-right-item" @click="handleShowMap" v-if="productDetail.coordinate && productDetail.coordinate.longitude">
                            <img class="address-right-item-icon" src="@/assets/hotel-scenic/hotel-scenic-detail-address.png" />
                            <div class="address-right-item-txt">地图</div>
                        </div>
                        <div class="address-right-line" v-if="productDetail.coordinate && productDetail.coordinate.longitude"></div>
                        <div class="address-right-item" @click='call' style="margin-right: 0;">
                            <img class="address-right-item-icon" src="@/assets/hotel-scenic/hotel-scenic-detail-tel.png" />
                            <div class="address-right-item-txt">电话</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="background:#F2F5F8 ;width: 100%;height: 8px;"></div>
            <div class="content">
                <div class="content-title">赠票说明</div>
                <div class="content-tip" v-for="(tip, index) in productDetail.tagInstructionInfos" :key="index + 'tagInstructionInfos'">
                    <div class="content-tip-tipTitle" :style="{ backgrpund: tip.title.bkcolour, color: tip.title.colour }">{{ tip.title.name }}</div>
                    <div class="content-tip-contain">
                        <span class="content-tip-contain-item" :key="i + 'item1'" v-for="(note, i) in tip.notes" :style="{ color: note.colour }" v-html="note.content"></span>
                    </div>
                </div>
                <div class="content-tip" v-for="(tip, index) in productDetail.normalInstructionInfos" :key="index + 'normalInstructionInfos'">
                    <div class="content-tip-title">{{ tip.title.name }}</div>
                    <div class="content-tip-contain">
                        <span class="content-tip-contain-item" :key="i + 'item'" v-for="(note, i) in tip.notes" :style="{ color: note.colour }" v-html="note.content"></span>
                    </div>
                </div>
            </div>

        </div>
    </loading>
</template>

<script>
import swipeComp from "../detail/components/swipe.vue";
import nativeApi from "@/utils/nativeApi";
import service from "@/service";
import get from "@/utils/get";
import env from "@/utils/env";
import loading from "@/components/c-loading.vue";

export default {
    components: { swipeComp, loading },
    data() {
        return {
            isLoading: true,
            // axiosObjBook: {
            //     productId: "",
            //     startDate: "",
            //     endDate: "",
            //     scenicSpotId: this.$route.query.scenicSpotId,
            //     pid: "215049",
            //     packageId: "",
            // },
            swipeShow: true,
            productDetail: {
                // "scenicSpotId": "",
                // "scenicSpotName": "黄鹤楼《鹤舞楚天》演出票(含日场门票)成人票10:30-11:00点入场",
                // "category": "",
                // "productId": "",
                // "productName": "",
                // "productOriginalPrice": 0.01,
                // "productPrice": 0.01,
                // "images": [
                //     ""
                // ],
                // "level": "",
                // "operatingStatus": 0,
                // "scenicSpotOpenTimes": [
                //     {
                //         "dateDesc": "09:00",
                //         "timeDesc": "开放",
                //         "lastInTime": "11:30"
                //     }
                // ],
                // "otherOpenTimeDesc": "",
                // "address": "湖北省武汉市武昌区武路路西山坡特 1 号",
                // "coordinate": {
                //     "longitude": 0.0,
                //     "latitude": 0.0
                // },
                // "phone": "",
                // "tagInstructionInfos": [
                //     {
                //         "title": {
                //             "name": "退改说明",
                //             "bkcolour": "rgba(255, 178, 116, 1)",
                //             "colour": "rgba(234, 109, 7, 1)",
                //             "icon": "",
                //         },
                //         "notes": [
                //             {
                //                 "content": "随酒店购买赠送的景点门票不支持退改；<br/>取消酒店预订时，赠送门票跟随酒店退票；<br/>超时未使用赠送门票服务视为自动过期作废；<br/>赠送服务不支持折现、退款等",
                //                 "colour": "rgba(87, 87, 87, 1)",
                //             }
                //         ],

                //     }
                // ],
                // "normalInstructionInfos": [{
                //     "title": {
                //         "name": "领取方式",
                //         "bkcolour": "rgba(255, 178, 116, 1)",
                //         "colour": "rgba(234, 109, 7, 1)",
                //         "icon": "",
                //     },
                //     "notes": [
                //         {
                //             "content": "酒店订单确认后，在酒店订单详情立即领取门票。领取时可任意选择1份景点进行领取，",
                //             "colour": "rgba(87, 87, 87, 1)",
                //         },
                //         {
                //             "content": "领取需支付1分钱用于系统创建门票订单",
                //             "colour": "rgba(234, 109, 7, 1)",
                //         },
                //     ],

                // }],

            },
            operatingStatusObj: [
                {
                    label: '已停业',
                    color: '#878787'
                },
                {
                    label: '营业中',
                    color: '#0AAB34'
                },
                {
                    label: '暂停营业',
                    color: '#878787'
                },
                {
                    label: '即将营业',
                    color: '#587193'
                },
                {
                    label: '已闭园',
                    color: '#587193'
                },
            ],

        }
    },
    methods: {
        goBack() {
            // this.$router.back();
            this.$page.back();

        },
        // 详情头部215044
        getData(scenicSpotId) {
            let obj = {
                scenicSpotId: this.$route.query.scenicSpotId,
            };
            return service.r521004(obj).then((res) => get(res, "res.bd.data", []));
        },
        call() {
            window.location.href = "tel:400-898-9999";
        },
        //打开详情
        openIntroduction() {
            const query = {
                title: this.productDetail.scenicSpotName,
                scenicSpotId: this.productDetail.scenicSpotId,
            };
            // const page = { path: "/scenic-introduction", query };
            // this.$router.push(page);

            const page = {
                url: "/scenic-introduction",
                name: "scenic-introduction",
                query: query,
                params: {},
            };
            this.$page.push(page);
        },
        // 查看地图
        handleShowMap() {
            // if (!this.productData.longitude || !this.productData.latitude) {
            //   return;
            // }
            // console.log("------------", this.productDetail.title);
            if (env.isNative) {
                nativeApi
                    .invoke("showMap", {
                        userLoc: true,
                        name: this.productDetail.scenicSpotName || this.productDetail.productName,
                        address: this.productDetail.address,
                        lng: this.productDetail.coordinate.longitude,
                        lat: this.productDetail.coordinate.latitude,
                    })
                    .catch(() => { });
            } else {
                location.href = `https://uri.amap.com/marker?position=${this.productDetail.coordinate.longitude},${this.productDetail.coordinate.latitude}&name=${this.productDetail.scenicSpotName}&coordinate=gaode&callnative=0`;
            }
        },

    },
    beforeCreate() {
        if (env.isNative) {
            nativeApi.invoke("updateHeaderRightBtn", {
                action: "hide",
                icon: "",
                text: "",
                data: {},
            });
            nativeApi.invoke("setNavigationBarVisible", { value: "0" });
            nativeApi.invoke("setNavigationBarTintColor", { statusBarStyle: "1" });
        }
    },
    computed: {
        axiosObj() {
            return {
                // productId: this.axiosObjProductId,
                startDate: "",
                endDate: "",
                scenicSpotId: this.$route.query.scenicSpotId,
                // pid: "215049",
                // packageId: this.axiosObjPackageID,
            };
        },
    },
    created() {
        this.getData().then((data) => {
            if (data) {
                this.isLoading = false
                this.productDetail = data
            }
        })
    },
}
</script>

<style lang='scss' scoped>
@import "@/scss/_vars.scss";

.hotel-scenic-new-detail {
    position: relative;
    padding-bottom: 38 * $px;
}

.toBackImg {
    width: 28 * $px;
    height: 28 * $px;
    position: fixed;
    top: 52 * $px;
    left: 12 * $px;
    z-index: 2;
}

.slider {
    position: relative;
    width: 375 * $px;
    height: 242 * $px;

    // margin-bottom: 121 * $px;

}

.mainTitleWrap {
    position: absolute;
    left: 0;
    top: 230 * $px;
    right: 0;
    // width: 359 * $px;
    height: 15 * $px;
    background: #ffffff;
    border-top-left-radius: 12 * $px;
    border-top-right-radius: 12 * $px;
}

.main-title {
    width: 375*$px;
    background: #ffffff;
    padding: 0 12*$px;
    box-sizing: border-box;
    padding-bottom: 12*$px;

    .price {
        display: inline-block;
        box-sizing: border-box;
        align-items: baseline;
        margin-bottom: 14*$px;

        .price-unit {
            font-family: GaoTieGuanJia-Medium;
            font-family: PingFangSC-Medium;

            font-weight: 500;
            font-size: 13*$px;
            color: #FF6347;
        }

        .price-txt {
            font-family: GaoTieGuanJia-SNaNpxiBold;
            font-family: PingFangSC-Medium;

            font-weight: 600;
            font-size: 22*$px;
            color: #FF6347;
            margin-right: 6*$px;
        }

        .price-del {
            font-family: SanFranciscoDisplay-Regular;
            font-family: PingFangSC-Medium;

            font-weight: 400;
            font-size: 13*$px;
            color: #878787;
        }

        .price-tip {
            margin-left: 8*$px;
            height: 16*$px;
            background: #FEF7EA;
            border-radius: 4*$px;
            padding: 0 4*$px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 11*$px;
            color: #9D5418;
        }
    }

    .title {
        width: 351*$px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 16*$px;
        color: #101010;
        line-height: 22*$px;
        margin-bottom: 12*$px;
    }

    .time {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .time-left {
            width: 268*$px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 13*$px;
            color: #101010;
        }

        .time-right {
            display: flex;
            align-items: center;
            justify-content: center;

            .time-right-txt {
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 13*$px;
                color: #575757;
                margin-right: 7*$px;
            }

            .time-right-icon {
                width: 6px;
                height: 10px;
            }

        }

    }

    .line {
        width: 351*$px;
        height: 0.5px;
        background-color: #EBEBEB;
        margin: 12*$px 0;
    }

    .address {
        display: flex;
        justify-content: space-between;
        align-items: center;


        .address-left {
            width: 200*$px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 13*$px;
            color: #101010;
            line-height: 18*$px;
        }

        .address-right {
            display: flex;
            align-items: center;

            .address-right-line {
                width: 0.5px;
                height: 22*$px;
                background-color: #EBEBEB;
                margin: 0 16*$px;

            }

            .address-right-item {
                display: flex;
                flex-direction: column;
                align-items: center;

                .address-right-item-icon {
                    width: 22*$px;
                    height: 22*$px;
                    margin-bottom: 2*$px;
                }

                .address-right-item-txt {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 11*$px;
                    color: #575757;
                }
            }
        }

    }


}





.content {
    width: 100%;
    padding-top: 20*$px;
    padding: 20*$px 12*$px;
    background-color: #ffffff;
    box-sizing: border-box;

    .content-title {
        font-family: PingFangSC;
        font-weight: 500;
        font-size: 18*$px;
        color: #101010;
        margin-bottom: 20*$px;
    }

    .content-tip {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 20*$px;

        .content-tip-tipTitle {
            height: 16*$px;
            border: 0.5px solid #FFB274;
            border-radius: 4*$px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 11*$px;
            color: #EA6D07;
            text-align: center;
            padding: 0 4*$px;
        }

        .content-tip-title {
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 13*$px;
        }

        .content-tip-contain {
            width: 266*$px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 13*$px;
            color: #575757;
            line-height: 18*$px;
        }

    }
}
</style>